module.exports = __webpack_public_path__ + "img/aussi.240790fc.svg";